import { Kpi, ChartCard, LineTrend, fmtZAR } from "./widgets";

export default function AdminAnalytics({ data }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="admin-kpis">
        <Kpi label="Incomplete onboardings" value={data.incomplete_onboardings || 0} accent="#F59E0B" testId="kpi-admin-onboarding" />
        <Kpi label="Account apps pending" value={data.account_apps_pending || 0} accent="#A78BFA" testId="kpi-admin-apps" />
        <Kpi label="Stale leads" value={data.stale_leads || 0} accent="#F43F5E" testId="kpi-admin-stale" note=">30 days untouched" />
        <Kpi label="Overdue services" value={data.overdue_services || 0} accent="#F43F5E" testId="kpi-admin-overdue" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Kpi label="Outstanding invoices" value={fmtZAR(data.outstanding_invoice_value)} accent="#F43F5E" testId="kpi-admin-outstanding" />
        <Kpi label="Portal adoption" value={data.portal_adoption_pct || 0} unit="%" accent="#10B981" testId="kpi-admin-adoption" note={`${data.customers_with_portal || 0} / ${data.customers_total || 0} customers`} />
        <Kpi label="Data completeness" value={data.data_completeness_pct || 0} unit="%" accent="#1FB6C1" testId="kpi-admin-completeness" note={`${data.data_missing_phone_or_email || 0} customers missing phone/email`} />
        <Kpi label="Customers" value={data.customers_total || 0} accent="#A78BFA" testId="kpi-admin-customers" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ChartCard title="Document uploads" desc="Daily new customer documents" testId="chart-admin-docs">
          <LineTrend data={data.doc_upload_trend} xKey="date" yKey="count" color="#1FB6C1" />
        </ChartCard>
        <div className="hv-card p-4 text-sm text-[#a0aabf] space-y-3">
          <h3 className="font-display font-bold text-base text-white">Workflow health checklist</h3>
          <ul className="space-y-2 text-xs" data-testid="admin-checklist">
            <ChecklistRow value={data.stale_leads} threshold={10} label="Stale leads" good="On top of your pipeline" bad="Reach out this week" />
            <ChecklistRow value={data.overdue_services} threshold={3} label="Overdue services" good="All services on track" bad="Schedule urgently" />
            <ChecklistRow value={data.account_apps_pending} threshold={1} label="Account apps pending" good="No apps awaiting review" bad="Credit decisions pending" invert />
            <ChecklistRow value={data.incomplete_onboardings} threshold={5} label="Incomplete onboardings" good="All onboardings completed" bad="Chase these forms" />
            <ChecklistRow value={data.data_missing_phone_or_email} threshold={10} label="Customers missing contact info" good="Contact data looks great" bad="Fill in missing phone/email" />
          </ul>
        </div>
      </div>
    </div>
  );
}

function ChecklistRow({ value, threshold, label, good, bad, invert = false }) {
  const num = value || 0;
  const healthy = invert ? num <= threshold : num < threshold;
  return (
    <li className="flex items-center gap-2">
      <span
        className={`w-1.5 h-1.5 rounded-full ${healthy ? "bg-emerald-400" : "bg-rose-400"} shrink-0`}
      />
      <span className="flex-1">
        <span className="text-white font-medium">{label}</span>
        <span className="text-[#a0aabf]"> · </span>
        <span className={healthy ? "text-emerald-300" : "text-rose-300"}>
          {healthy ? good : bad}
        </span>
      </span>
      <span className="font-mono text-[#a0aabf] shrink-0">{num}</span>
    </li>
  );
}
